const $ = jQuery.noConflict();

'use strict';
const CustomerSearch = {
	/** @description Initialize */

	init: function() {
		this.bindEvents();
	},
	bindEvents: () => {

		$('.js-search-customers').keyup(function() {
			const filter = $(this).val();

			$('.js-single-customer').each(function() {
				if ($(this).text().search(new RegExp(filter, 'i')) < 0) {
					$(this).fadeOut();
				} else {
					$(this).show();
				}
			});
		});

		$('.js-search-wrap').on('click', '.js-login-popup', function(ele) {
			const popup = document.getElementsByClassName('js-popup-login-form');
			popup[0].classList.add('active');
			popup[0].setAttribute('data-id', ele);
		});
	}
};

export default CustomerSearch;
